import React, { createContext, useContext, useState } from 'react';
import MessageBox from './MessageBox';

const MessageBoxContext = createContext();

export const useMessageBox = () => {
  const context = useContext(MessageBoxContext);
  if (!context) {
    throw new Error('useMessageBox must be used within MessageBoxProvider');
  }
  return context;
};

export const MessageBoxProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  const showMessage = (message, type, duration = 0) => {
    const id = Date.now();
    setMessages((prev) => [...prev, { id, message, type, duration }]);
    return id;
  };

  const hideMessage = (id) => {
    setMessages((prev) => prev.filter((msg) => msg.id !== id));
  };

  const success = (message, duration = 5000) => showMessage(message, 'success', duration);
  const error = (message, duration = 0) => showMessage(message, 'error', duration);
  const warning = (message, duration = 6000) => showMessage(message, 'warning', duration);
  const info = (message, duration = 5000) => showMessage(message, 'info', duration);
  const loading = (message) => showMessage(message, 'loading', 0);

  return (
    <MessageBoxContext.Provider value={{ success, error, warning, info, loading, hideMessage }}>
      {children}
      {messages.map((msg) => (
        <MessageBox
          key={msg.id}
          message={msg.message}
          type={msg.type}
          duration={msg.duration}
          onClose={() => hideMessage(msg.id)}
        />
      ))}
    </MessageBoxContext.Provider>
  );
};

export default MessageBoxProvider;